var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.addOns.length > 0
    ? _c(
        "div",
        {
          staticClass: "product-settings",
          class: {
            "product-settings--open": _vm.showAddOns,
            "product-settings--modal": _vm.type == "modal"
          }
        },
        [
          _c(
            "button",
            {
              staticClass: "product-settings__toggle",
              class: {
                "product-settings__toggle--active": _vm.showAddOns,
                "product-settings__toggle--small": _vm.type == "modal"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toggleAddOns($event)
                }
              }
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$modeoL10n.additional_options) + " "
              ),
              _c(
                "span",
                { staticClass: "product-settings__sum" },
                [
                  _c("price", {
                    attrs: {
                      prefix: "+",
                      "price-without-tax": _vm.addOnTotalWithoutTax,
                      "price-with-tax": _vm.addOnTotalWithTax
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.showAddOns
            ? _c(
                "div",
                { staticClass: "product-settings__content" },
                _vm._l(_vm.addOns, function(addOn, index) {
                  return _c(
                    "div",
                    { key: addOn.id, staticClass: "product-setting" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "product-setting__label",
                          attrs: { for: "addon-" + addOn.id }
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(_vm.$modeoL10n.as_addon) + " "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "product-setting__name content-link",
                              attrs: { href: addOn.link, target: "_blank" }
                            },
                            [_vm._v(_vm._s(addOn.name))]
                          ),
                          _vm._v(" "),
                          addOn.lead != ""
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "product-info-popover-button info-btn",
                                  class: {
                                    "state-active": _vm.addOnInfo[index]
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.toggleAddonInfo(index)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "screen-reader-text" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$modeoL10n
                                            .additional_info_accessory
                                        ) +
                                          " " +
                                          _vm._s(addOn.name)
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.addOnInfo[index]
                            ? _c(
                                "div",
                                { staticClass: "product-info-popover" },
                                [
                                  addOn.image
                                    ? _c("img", {
                                        directives: [
                                          {
                                            name: "lazy",
                                            rawName: "v-lazy",
                                            value: addOn.image.productThumbnail,
                                            expression:
                                              "addOn.image.productThumbnail"
                                          }
                                        ],
                                        staticClass:
                                          "product-info-popover__image",
                                        attrs: {
                                          srcset:
                                            addOn.image.productThumbnail +
                                            " 1x, " +
                                            addOn.image.productThumbnailX2 +
                                            " 2x",
                                          alt: ""
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "product-info-popover__text"
                                    },
                                    [_vm._v(_vm._s(addOn.lead))]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "product-setting__value" }, [
                        _c(
                          "div",
                          { staticClass: "product-setting__field select" },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedAddOns[addOn.id],
                                    expression: "selectedAddOns[addOn.id]"
                                  }
                                ],
                                attrs: { id: "addon-" + addOn.id },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.selectedAddOns,
                                        addOn.id,
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function($event) {
                                      return _vm.addOnsChanged()
                                    }
                                  ]
                                }
                              },
                              [
                                _c("option", { domProps: { value: false } }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$modeoL10n.select) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                !addOn.variations
                                  ? _c(
                                      "option",
                                      { domProps: { value: addOn } },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$modeoL10n.yes) +
                                            " "
                                        ),
                                        !_vm.hidePrices
                                          ? [
                                              _vm._v("\n                ("),
                                              _c("price", {
                                                attrs: {
                                                  prefix: "+",
                                                  "price-without-tax":
                                                    addOn.prices_without_tax
                                                      .price,
                                                  "price-with-tax":
                                                    addOn.prices_with_tax.price
                                                }
                                              }),
                                              _vm._v(")\n              ")
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                addOn.variations
                                  ? _vm._l(addOn.variations, function(
                                      variation
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: variation.variation_id,
                                          domProps: { value: variation }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(variation.attribute_name) +
                                              " "
                                          ),
                                          !_vm.hidePrices
                                            ? [
                                                _vm._v("\n                  ("),
                                                _c("price", {
                                                  attrs: {
                                                    prefix: "+",
                                                    price: variation.price,
                                                    "price-without-tax":
                                                      variation
                                                        .prices_without_tax
                                                        .price,
                                                    "price-with-tax":
                                                      variation.prices_with_tax
                                                        .price
                                                  }
                                                }),
                                                _vm._v(")\n                ")
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    })
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.selectedAddOns[addOn.id]
                          ? _c(
                              "span",
                              { staticClass: "product-setting__price" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "product-setting__price-amount price-amount",
                                    class: {
                                      "price-amount--ins":
                                        _vm.selectedAddOns[addOn.id].price !=
                                        _vm.selectedAddOns[addOn.id]
                                          .regular_price
                                    }
                                  },
                                  [
                                    _c("price", {
                                      attrs: {
                                        price:
                                          _vm.selectedAddOns[addOn.id].price,
                                        "price-without-tax":
                                          _vm.selectedAddOns[addOn.id]
                                            .prices_without_tax.price,
                                        "price-with-tax":
                                          _vm.selectedAddOns[addOn.id]
                                            .prices_with_tax.price
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.selectedAddOns[addOn.id].price !=
                                _vm.selectedAddOns[addOn.id].regular_price
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "product-setting__price-amount price-amount price-amount--del"
                                      },
                                      [
                                        _c("price", {
                                          attrs: {
                                            price:
                                              _vm.selectedAddOns[addOn.id]
                                                .regular_price,
                                            "price-without-tax":
                                              _vm.selectedAddOns[addOn.id]
                                                .prices_without_tax
                                                .regular_price,
                                            "price-with-tax":
                                              _vm.selectedAddOns[addOn.id]
                                                .prices_with_tax.regular_price
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b84eb3fc", { render: render, staticRenderFns: staticRenderFns })
  }
}